/**
 * Invoice totals math — mirrors the backend (server.py _compute_*). Tax is
 * applied to taxable_amount (sum of taxable lines), NOT the full subtotal.
 * discountTotal is the sum of negative-amount lines (non-positive). All values
 * rounded to cents to match the backend's round(..., 2). Keeping these in one
 * tested module guards the six-value FE↔BE reconciliation from FE-side drift.
 */
const round2 = (n) => +Number(n).toFixed(2);

export function computeSubtotal(lineItems) {
  let total = 0;
  for (const it of lineItems) {
    const a = Number(it.amount);
    if (Number.isFinite(a)) total += a;
  }
  return round2(total);
}

export function computeTaxableAmount(lineItems) {
  let total = 0;
  for (const it of lineItems) {
    if (!it.taxable) continue;
    const a = Number(it.amount);
    if (Number.isFinite(a)) total += a;
  }
  return round2(total);
}

export function computeDiscountTotal(lineItems) {
  let total = 0;
  for (const it of lineItems) {
    const a = Number(it.amount);
    if (Number.isFinite(a) && a < 0) total += a;
  }
  return round2(total);
}
